import React from 'react';
import { Box, Button, Typography, Table, TableBody, TableHead, TableRow, Checkbox, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PropTypes from 'prop-types';
import { commonStyles as styles } from 'assets/style';
import { StyledTableCell } from '../../style';
import StyleTextField from '../../styleTextField';

const MetaDataTags = ({
    tags,
    addtags,
    errors,
    isAllChecked,
    allSelected,
    handleInputChange,
    handleInputTags,
    handleAddNewRow,
    handleSaveTags,
    handleDeleteAllSelected,
    handleRowCheck,
    handleDeleteRow,
    handleSelectAll,
}) => (
    <>
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                width: '1135px',
                paddingBottom: '10px',
            }}
        >
            <Typography
                sx={{
                    marginRight: '10px',
                    fontSize: '16px',
                    color: '#0047BA',
                    fontWeight: '500',
                }}
            >
                Meta Data Tags
            </Typography>
            <Box sx={{ display: 'flex', marginLeft: 'auto', gap: '10px' }}>
                <Button
                    sx={{ ...styles.modalSaveButton, height: '36px', width: '139px' }}
                    variant="contained"
                    disableElevation
                    disableRipple
                    onClick={handleAddNewRow}
                >
                    Add New Tag
                </Button>
                <Button
                    sx={{ ...styles.modalSaveButton, height: '36px', width: '139px' }}
                    variant="contained"
                    disableElevation
                    disableRipple
                    onClick={handleSaveTags}
                >
                    Save Tags
                </Button>
                {allSelected && addtags.length >= 1 && (
                    <Button
                        sx={{
                            ...styles.primaryMediumDangerButton,
                            '&.MuiButton-root:hover': {
                                backgroundColor: (theme) => `${theme.palette.background.$color_background_button_primary_danger_hover}!important`,
                            },
                            height: '36px',
                            width: '187px',
                        }}
                        variant="contained"
                        disableElevation
                        disableRipple
                        onClick={handleDeleteAllSelected}
                    >
                        Delete All Selected
                    </Button>
                )}
            </Box>
        </Box>
        <Table>
            <TableHead sx={{ backgroundColor: (theme) => theme.palette.cyan['90'], borderTop: '1px solid rgba(0, 0, 0, 0.12)' }}>
                <TableRow>
                    <StyledTableCell sx={{ width: '40px', padding: '4px 8px', color: '#005CBC', fontSize: '14px', fontWeight: '700' }}>
                        <Checkbox sx={{ color: '#005CBC' }} checked={isAllChecked} onChange={handleSelectAll} />
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: '200px', padding: '12px 12px', color: '#005CBC', fontSize: '14px', fontWeight: '700' }}>
                        Tag Name
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: '100px', padding: '12px 12px', color: '#005CBC', fontSize: '14px', fontWeight: '700' }}>
                        Value
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: '100px', padding: '12px 12px', color: '#005CBC', fontSize: '14px', fontWeight: '700' }} />
                </TableRow>
            </TableHead>
            <TableBody>
                {tags.map((row, index) => (
                    <TableRow key={index} sx={{ height: '40px' }}>
                        <StyledTableCell sx={{ width: '40px', padding: '12px 12px' }} />
                        <StyledTableCell sx={{ padding: '12px 12px', width: '200px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                {row.mkey !== 'drift_distance_threshold' ? <Typography sx={{ color: '#E4080A', marginRight: '4px' }}>*</Typography> : null}
                                {row.name}
                                {row.tooltipInfo && (
                                    <Tooltip
                                        title={row.tooltipInfo}
                                        arrow
                                        componentsProps={{
                                            tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                                            arrow: { sx: { color: '#272727' } },
                                        }}
                                    >
                                        <InfoOutlinedIcon
                                            sx={{
                                                fontSize: '16px',
                                                color: '#005CBC',
                                                marginLeft: '8px',
                                                cursor: 'pointer',
                                            }}
                                        />
                                    </Tooltip>
                                )}
                            </Box>
                        </StyledTableCell>
                        <StyledTableCell sx={{ padding: '12px 12px', width: '100px' }}>
                            <StyleTextField
                                value={row.mvalue}
                                onChange={(e) => handleInputChange(index, 'mvalue', e.target.value)}
                                variant="filled"
                                fullWidth={row.mkey === 'baseline_datasource'}
                                sx={{
                                    '&.MuiTextField-root': {
                                        border: 'none',
                                    },
                                    width: row.mkey === 'baseline_datasource' ? '500px' : '200px',
                                    border: `1px solid ${errors[index] ? '#d40020' : '#1378D4'}`,
                                }}
                                inputProps={{
                                    style: { padding: '4px' },
                                }}
                            />
                            {errors[index] && <Typography sx={{ color: '#d40020', fontSize: '12px', marginTop: '4px' }}>{errors[index]}</Typography>}
                            {row.mkey === 'baseline_datasource' && (
                                <Typography sx={{ fontSize: '10px', color: 'grey', marginTop: '4px' }}>
                                    Example: https://iaimlops.blob.core.windows.net/dlops-container/OC/baseline/dlops-model-oc/baseline_dlops-oc_20240425.csv
                                </Typography>
                            )}
                        </StyledTableCell>
                    </TableRow>
                ))}

                {addtags &&
                    addtags.length > 0 &&
                    addtags.map((row, index) => (
                        <TableRow key={index}>
                            <StyledTableCell sx={{ width: '40px', padding: '12px 12px' }}>
                                <Checkbox checked={row.isChecked} onChange={() => handleRowCheck(index)} />
                            </StyledTableCell>
                            <StyledTableCell sx={{ padding: '12px 12px', width: '200px' }}>
                                <StyleTextField
                                    value={row.name}
                                    onChange={(e) => handleInputTags(index, 'name', e.target.value)}
                                    variant="filled"
                                    sx={{
                                        marginTop: '8px',
                                        borderRadius: '4px',
                                    }}
                                    inputProps={{
                                        style: { padding: '4px' },
                                    }}
                                />
                            </StyledTableCell>
                            <StyledTableCell sx={{ padding: '12px 12px', width: '100px' }}>
                                <StyleTextField
                                    value={row.value}
                                    onChange={(e) => handleInputTags(index, 'value', e.target.value)}
                                    variant="filled"
                                    sx={{
                                        marginTop: '8px',
                                        borderRadius: '4px',
                                    }}
                                    inputProps={{
                                        style: { padding: '4px' },
                                    }}
                                />
                            </StyledTableCell>
                            <StyledTableCell sx={{ width: '100px', padding: '12px 12px' }}>
                                {row.isChecked && (
                                    <Typography
                                        onClick={() => handleDeleteRow(index)}
                                        sx={{ color: '#1378D4', textDecoration: 'underline', cursor: 'pointer' }}
                                    >
                                        Delete
                                    </Typography>
                                )}
                            </StyledTableCell>
                        </TableRow>
                    ))}
            </TableBody>
        </Table>
    </>
);

MetaDataTags.propTypes = {
    tags: PropTypes.array.isRequired,
    addtags: PropTypes.array.isRequired,
    errors: PropTypes.object.isRequired,
    isAllChecked: PropTypes.bool.isRequired,
    allSelected: PropTypes.bool.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    handleInputTags: PropTypes.func.isRequired,
    handleAddNewRow: PropTypes.func.isRequired,
    handleSaveTags: PropTypes.func.isRequired,
    handleDeleteAllSelected: PropTypes.func.isRequired,
    handleRowCheck: PropTypes.func.isRequired,
    handleDeleteRow: PropTypes.func.isRequired,
    handleSelectAll: PropTypes.func.isRequired,
};

export default MetaDataTags;
